import { useEffect, useRef } from 'preact/hooks'

export default function useInterval(callback, delay) {
  const callbacRef = useRef()

  // update callback function with current render callback that has access to latest props and state
  useEffect(() => {
    callbacRef.current = callback
  })

  useEffect(() => {
    if (!delay) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {}
    }

    const interval = setInterval(() => {
      // @ts-ignore
      callbacRef.current && callbacRef.current()
    }, delay)
    return () => clearInterval(interval)
  }, [delay])
}
